var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckMarkFill({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0497 34.4015L15.0309 38.3839L18.0477 34.6335L18.0359 34.6177L18.2765 34.3156L36.0956 11.9469L33.3478 8.27621L15.6931 30.4427L15.2897 30.9491L14.9017 30.4308L8.06146 21.2933L5.64447 25.845L12.0497 34.4015Z",
    fill: "white",
    stroke: "white"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTIuMDQ5NyAzNC40MDE1TDE1LjAzMDkgMzguMzgzOUwxOC4wNDc3IDM0LjYzMzVMMTguMDM1OSAzNC42MTc3TDE4LjI3NjUgMzQuMzE1NkwzNi4wOTU2IDExLjk0NjlMMzMuMzQ3OCA4LjI3NjIxTDE1LjY5MzEgMzAuNDQyN0wxNS4yODk3IDMwLjk0OTFMMTQuOTAxNyAzMC40MzA4TDguMDYxNDYgMjEuMjkzM0w1LjY0NDQ3IDI1Ljg0NUwxMi4wNDk3IDM0LjQwMTVaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgCheckMarkFill as ReactComponent };